import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Warning = ({
  className,
  color = '#CA2121',
  width = 24,
  height = 24,
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
      fill={color}
    >
      <path d="M2 19h20L12 2 2 19Zm10.9091-2.6842h-1.8182v-1.7895h1.8182v1.7895Zm0-3.579h-1.8182V9.15789h1.8182v3.57891Z" />
    </svg>
  );
};
